import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import classNames from 'classnames';
import AbstractTextElement from './AbstractTextElement';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Small(_ref) {
  let {
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AbstractTextElement, Object.assign({}, rest, {
    className: classNames('private-microcopy', className)
  }));
}
Small.propTypes = AbstractTextElement.propTypes;
Small.defaultProps = Object.assign({}, AbstractTextElement.defaultProps, {
  tagName: 'small'
});
Small.displayName = 'Small';